const productList = () => import('@/pages/product/index.vue');
const productForm = () => import('@/pages/product/form.vue');

export default [{
    path: '/product/list',
    component: productList,
    meta: [{
        name: '产品管理'
    },
    {
        name: '产品列表',
        activeRoute: '/product/list'
    }]
},{
	path: '/product/form',
	component: productForm,
	meta: [{
        name: '产品管理'
    },
    {
        name: '产品列表',
        url: '/product/list'
    },
    {
        name: '新增/编辑',
        activeRoute: '/product/list'
    }]
}];